import discardWeatherOption from './data/mutators/discardWeatherOption';
import saveWeatherOption from './orchestration/saveWeatherOption';
import WeatherFull from './view/WeatherFull';
import isWeatherOptionDirty from './utils/isWeatherOptionDirty';
import * as React from 'react';
var WeatherOption = {
    key: 'weatherOption',
    titleStringKey: 'optionTitle_weather',
    searchTermsStringKey: 'optionTitle_weather',
    fullOptionFormSettings: {
        render: function () { return React.createElement(WeatherFull, null); },
        isDirty: isWeatherOptionDirty,
        onSave: saveWeatherOption,
        onDiscard: discardWeatherOption,
    },
};
export default WeatherOption;
//# sourceMappingURL=WeatherOption.js.map